import { atom, atomWithDefault } from '~shared/lib/atom-state';

import { getProfile } from '../api';

import { IProfile } from './types';

export const profileAtom = atomWithDefault<IProfile | null>((_get) => null);

export const setProfileAtom = atom(
  (get) => get(profileAtom),
  async (_get, set) => {
    const response = await getProfile();

    if (response.data?.error) {
      set(profileAtom, null);
    } else if (response.data) {
      set(profileAtom, response.data);
    }
  }
);
